<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import { derived, get } from "svelte/store";

  import { FileMgr } from "../stores/FileMgr";

  import ProcMgr from "../stores/ProcMgr";

  const procmgr = ProcMgr.getInstance();
  const filemgr = FileMgr.getInstance();
  const { isModal, modalStore } = procmgr;
  let modalButtonCount = derived(modalStore, (store) => {
    if (store.buttons.length !== store.callbacks.length) {
      throw new Error(
        `Modal button and callback count does not match. Button count : ${store.buttons.length}, Callback count : ${store.callbacks.length}`
      );
    }
    return store.buttons.length;
  });

  const handleKeydown = (e) => {
    // 'Enter' : left button
    // 'ESC' : right button

    e.preventDefault();
    const keyMap = {
      Enter: () => {
        $modalStore.callbacks.at(0)?.();
      },
      Escape: () => {
        $modalStore.callbacks.at($modalButtonCount - 1)?.();
      },
    };
    keyMap[e.key]?.();
    if (keyMap[e.key]) {
      procmgr.closeModal();
    }
  };

  let buttons: HTMLElement;
  let okBtn: HTMLAnchorElement;
  let modalElem: HTMLElement;
  onMount(() => {
    //give some delay
    setTimeout(() => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
        window.addEventListener("keydown", handleKeydown);
      }
    }, 500);
    setTimeout(() => {
      modalElem?.classList.add("active");
    }, 1);
  });
  onDestroy(() => {
    window.removeEventListener("keydown", handleKeydown);
  });
</script>

<div class="container">
  <div class="background" on:click={(e) => procmgr.closeModal()} />
  <div class="contents-container" bind:this={modalElem}>
    <div class="contents">
      <div class="title">
        {$modalStore.title}
      </div>
      <div class="descs">
        {#each $modalStore.descs as desc}
          <div class="desc">{desc}</div>
        {/each}
      </div>

      <div class="buttons" bind:this={buttons}>
        {#each $modalStore.buttons as btn, i (i)}
          <button
            class="btn"
            on:click={() => {
              $modalStore.callbacks[i]();
              procmgr.closeModal();
            }}>{btn}</button
          >
        {/each}
      </div>
    </div>
  </div>
  <div class="css-keeper contents-container active" />
</div>

<style>
  .container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
  }
  .background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #333a;
  }
  .contents-container {
    position: absolute;
    width: 100%;
    height: 30%;
    top: 50%;
    min-height: 300px;
    transform: translateY(-50%);
    background-color: #dbdbdb;
    opacity: 0;
    transition: 0.3s;
  }
  .contents-container.active {
    opacity: 1;
    box-shadow: 0px 2px 6px #333a;
  }
  .contents {
    position: absolute;
    width: 50%;
    height: 80%;
    top: 10%;
    left: 25%;
    /* transform: translateY(-50%); */
    display: flex;
    flex-direction: column;
  }
  .title {
    font-size: 2.5rem;
    flex: 1;
  }
  .descs {
    font-size: 1.5rem;
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .buttons {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 30px;
  }
  .btn {
    margin: 0;
    padding: 10px;
    box-sizing: border-box;
    flex: 1;
    font-size: 2rem;
    box-shadow: 0px 0px 1px #333;
    transition: 0.2s;
  }
  .btn:hover {
    cursor: pointer;
    box-shadow: 2px 2px 4px #333;
    transform: translate(-2px, -2px);
  }
  .btn:active {
    transition: 50ms;
    box-shadow: 0px 0px 0px #333;
    transform: translate(0px, 0px);
  }
  .css-keeper {
    display: none;
  }
</style>
